import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { initialState } from "./state";

import { ColorScheme } from "../types/ColorScheme";

import { userApi } from "services/streamingApi/user.api";

// slice
export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        selectNextAvailableColorScheme: (state) => {
            if (!state.usersettings) {
                return;
            }

            if (state.usersettings.colorScheme === ColorScheme.Light) {
                state.usersettings.colorScheme = ColorScheme.Dark;
            } else if (state.usersettings.colorScheme === ColorScheme.Dark) {
                state.usersettings.colorScheme = ColorScheme.System;
            } else {
                state.usersettings.colorScheme = ColorScheme.Light;
            }

            state.isDirty = true;
        },
        toggleAudioEnabledByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.audioEnabledByDefault =
                !state.usersettings.audioEnabledByDefault;
            state.isDirty = true;
        },
        toggleGridViewEnableAutoSizing: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.gridViewEnableAutoSizing =
                !state.usersettings.gridViewEnableAutoSizing;
            state.isDirty = true;
        },
        toggleGridViewMaxNumberOfDevicesPerGridRow: (
            state,
            action: PayloadAction<number>,
        ) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.gridViewMaxNumberOfDevicesPerGridRow =
                action.payload;
            state.isDirty = true;
        },
        toggleShowUnrestrictedFeedsByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.showUnrestrictedFeedsByDefault =
                !state.usersettings.showUnrestrictedFeedsByDefault;
            state.isDirty = true;
        },
        toggleDebugToolsShowForwardAndReversedRecordingsByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.debugToolsShowForwardAndReversedRecordingsByDefault =
                !state.usersettings
                    .debugToolsShowForwardAndReversedRecordingsByDefault;
            state.isDirty = true;
        },
        toggleDebugToolsShowVideoDirectionInformationByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.debugToolsShowVideoDirectionInformationByDefault =
                !state.usersettings
                    .debugToolsShowVideoDirectionInformationByDefault;
            state.isDirty = true;
        },
        toggleDebugToolsShowRecordingsOutsidePlaybackAndBufferingWindowByDefault:
            (state) => {
                if (!state.usersettings) {
                    return;
                }

                state.usersettings.debugToolsShowRecordingsOutsidePlaybackAndBufferingWindowByDefault =
                    !state.usersettings
                        .debugToolsShowRecordingsOutsidePlaybackAndBufferingWindowByDefault;
                state.isDirty = true;
            },
        toggleDebugToolsShowStatisticsByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.debugToolsShowStatisticsByDefault =
                !state.usersettings.debugToolsShowStatisticsByDefault;
            state.isDirty = true;
        },
        toggleDebugToolsShowBufferingRecordingsByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.debugToolsShowBufferingRecordingsByDefault =
                !state.usersettings.debugToolsShowBufferingRecordingsByDefault;

            state.isDirty = true;
        },
        toggleDebugToolsShowSystemControlsByDefault: (state) => {
            if (!state.usersettings) {
                return;
            }

            state.usersettings.debugToolsShowSystemControlsByDefault =
                !state.usersettings.debugToolsShowSystemControlsByDefault;
            state.isDirty = true;
        },
        toggleJobRunsDialog: (state) => {
            state.showJobRunsDialog = !state.showJobRunsDialog;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            userApi.endpoints.putUserSettings.matchPending,
            (state) => {
                state.isSaving = true;
            },
        );
        builder.addMatcher(
            userApi.endpoints.putUserSettings.matchRejected,
            (state) => {
                state.isSaving = false;
                state.isDirty = false;
            },
        );
        builder.addMatcher(
            userApi.endpoints.putUserSettings.matchFulfilled,
            (state) => {
                state.isSaving = false;
                state.isDirty = false;
            },
        );
        builder.addMatcher(
            userApi.endpoints.getMySettings.matchFulfilled,
            (state, action) => {
                state.usersettings = action.payload;
                state.isSaving = false;
                state.isDirty = false;
            },
        );
    },
});

// exports
export const userActions = userSlice.actions;

export default userSlice.reducer;
